import React from 'react'

interface AppPlayIconProps {
  className?: string
  color?: string
  width?: string
  height?: string
}

export const AppPlayIcon: React.FC<AppPlayIconProps> = ({
  className = 'w-5 h-5',
  color = 'currentColor',
  width = '20',
  height = '20',
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 4L16 10L6 16V4Z"
        fill={color}
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default AppPlayIcon
